import { ClassData, MethodData } from '@/core/types/library.type'
import { getInstanceVariableName } from '@/core/utils/getInstanceVariableName'
import { isGlobalMethodType } from '@/core/utils/isGlobalMethodType'

import { formatCodeSnippetParams } from './formatCodeSnippetParams.builder'

export function buildCodeSnippet(
  method: MethodData,
  classData: ClassData,
  isStatic: boolean,
  useConstructors: boolean,
  instanceCode: string,
  usageCode: string,
  technology?: string
): string {
  const className = classData.name
  const instanceName = getInstanceVariableName(className, technology)
  const paramsStr = formatCodeSnippetParams(method.parameters.map((parameter) => parameter.name))
  const usage = isGlobalMethodType(method.type)
    ? usageCode
        .replaceAll('{class}.{method}', method.name)
        .replaceAll('${class}->{method}', method.name)
        .replaceAll('{class}::{method}', method.name)
        .replaceAll('{params}', paramsStr)
    : usageCode
        .replaceAll('{class}', isStatic ? className : instanceName)
        .replaceAll('{method}', method.name)
        .replaceAll('{params}', paramsStr)

  if (isStatic || useConstructors) return usage

  const instance = instanceCode.replaceAll('{class}', className).replace('{name}', instanceName).replace('{params}', '')

  return `${instance}\n${usage}`
}
